import React from 'react';
import { AbsoluteFill } from 'remotion';
import { CompositorManifest } from '../types/manifest';
import { BackgroundLayer } from './layers/BackgroundLayer';
import { ScreenLayer } from './layers/ScreenLayer';
import { WebcamLayer } from './layers/WebcamLayer';
import { AudioSegment } from './layers/AudioSegment';

interface CompositorCompositionProps {
  manifest: CompositorManifest;
  skipAudio?: boolean;
}

export const CompositorComposition: React.FC<CompositorCompositionProps> = React.memo(({
  manifest,
  skipAudio = false,
}) => {
  const sortedLayers = [...manifest.layers]
    .filter(layer => layer.visible !== false)
    .sort((a, b) => a.zIndex - b.zIndex);

  return (
    <AbsoluteFill
      style={{
        width: manifest.canvas.width,
        height: manifest.canvas.height,
        overflow: 'hidden',
        backgroundColor: 'transparent',
      }}
    >
      <BackgroundLayer config={manifest.background} />

      {sortedLayers.map(layer => {
        switch (layer.type) {
          case 'screen':
            return <ScreenLayer key={layer.id} layer={layer} />;
          case 'webcam':
            return <WebcamLayer key={layer.id} layer={layer} />;
          default:
            return null;
        }
      })}

      {!skipAudio && manifest.audioLayer?.segments.map(segment => (
        <AudioSegment key={segment.segmentId} segment={segment} />
      ))}
    </AbsoluteFill>
  );
});
